import { Bootstrapper } from "../Bootstrapper";
import { lumberjack } from "../Logging";

export class LoggingBootstrapper extends Bootstrapper {
    /**
     * @inheritDoc
     */
    public bootstrap(): MaybePromise<void> {
        if(process.env.NODE_ENV === "production") {
            lumberjack.inject();
        }
    }
}
